import styled from "styled-components";
import { Form } from "formik";
import { Modal } from "react-bootstrap";

export const ModalStyle = styled(Modal)`
    .modal-content {
        padding: 26px;
        border-radius: 10px;
        max-width: 500px;
        width: 100%;
    }
`;

export const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    span {
        color: #074F8C;
        font-size: 1.25rem;
        font-weight: 400;
    }
    svg {
        cursor: pointer;
        color: #074F8C;
    }
`;

export const Title = styled.h1`
    margin: 0;
    color: #074F8C;
    font-size: 1.25rem;
    font-weight: 400;
`;


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  h1 {
    margin-bottom: 20px;
  }
`;

export const Text = styled.p`
  color: #5e5e5e;
  font-size: 0.9375rem;
  font-weight: 400;
`;

export const Alert = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0;
  max-width: 267px;
  text-align: center;
  font-family: 'Mangueira';

  ul {
    padding-inline-start: 1rem;
    margin-bottom: 0;
  }
`;

export const FormContainer = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const FieldContainer = styled.div`
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  button {
    width: 100%;
  }
  margin-top: 30px;
`;

export const ContainerText = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 10px;
`;

export const IconContainer = styled.div`
  border: 5px solid #F0B01B;
  width: 46px;
  height: 46px;
  border-radius: 100%;
  display: flex;
  place-content: center;
  place-items: center;
`;